// extracted by mini-css-extract-plugin
export default {"status":"VehicleStatus_status__SlFUI","status__data__item":"VehicleStatus_status__data__item__6IKVr","block":"VehicleStatus_block__oaM2f"};